import { z } from 'zod'

// LF-918: the guidebook chatbot's wire formats. Everything the sidebar reads
// from the server — the mount config in the page, HTTP responses, cable
// broadcasts — is parsed here first (see app/lib/chatbot/serializer.rb).

export const PAGE_KINDS = ['report', 'home', 'demo'] as const
export type PageKind = (typeof PAGE_KINDS)[number]

export const MountConfig = z
  .object({
    pageKind: z.enum(PAGE_KINDS),
    pagePath: z.string().startsWith('/'),
    calcSessionId: z.string().uuid().nullable(),
    greeting: z.string(),
  })
  .strict()
export type MountConfig = z.infer<typeof MountConfig>

export const Message = z
  .object({
    id: z.string().uuid(),
    role: z.enum(['user', 'assistant']),
    status: z.enum(['pending', 'streaming', 'complete', 'failed']),
    revision: z.number().int().nonnegative(),
    content: z.string(),
    replyToId: z.string().uuid().nullable(),
    truncated: z.boolean(),
    error: z.string().nullable(),
  })
  .strict()
export type Message = z.infer<typeof Message>

export const StartedConversation = z
  .object({ id: z.string().uuid(), streamToken: z.string().min(1) })
  .strict()
export type StartedConversation = z.infer<typeof StartedConversation>

export const Asked = z.object({ question: Message, reply: Message }).strict()
export type Asked = z.infer<typeof Asked>

export const Transcript = z
  .object({ id: z.string().uuid(), messages: z.array(Message) })
  .strict()
export type Transcript = z.infer<typeof Transcript>

export const ApiError = z.object({
  error: z.string(),
  detail: z.string().optional(),
})

export const CableEvent = z
  .object({ v: z.literal(1), type: z.literal('message'), message: Message })
  .strict()

export const isInFlight = (message: Message) =>
  message.role === 'assistant' &&
  (message.status === 'pending' || message.status === 'streaming')
